<section id="who-section" class=" bg-white py-36 px-4">
  <div class="container relative">
    <h2
      class="text-3xl font-extrabold mb-20 text-center text-gray-800 capitalize"
    >
      Qui <span class="text-blue-800 "> suis-je ?</span>
    </h2>
    <div class="grid lg:grid-cols-2 md:grid-cols-1 gap-1">
      <div>
        <img
          class="mx-auto object-cover lg:w-96 lg:h-auto lg:rounded-md w-64 h-64 rounded-full"
          src="./images/moi.jpg"
          alt=""
          width="1505"
          height="2088"
        />
      </div>
      <div>
        <p class="text-xl text-blue-800 font-bold mb-1">
          Je m'appelle Hugo, je suis développeur Full Stack PHP.
        </p>
        <p class="text-gray-800 mb-5">
          Passionné par l'informatique, je me suis rapidement dirigé vers des
          études dans le développement web.<br />
          Après 7ans d'experience dans le developpement de solution web via le framework
          Symfony, je parfais mes compétences en front avec l'apprentissage de React
          et son framework Next. <br />
          Si vous voulez en savoir plus sur mes compétences, n'hésitez pas a vous
          rendre a la
          <a class="text-blue-500 underline" href="#ability-section"
            >section correspondante.</a
          >
        </p>
        <hr class="border-gray-400 mb-5" />
        <div class="grid grid-cols-2 gap-4 mb-10">
          <p>
            <span class="font-bold text-blue-800 mr-3">Nom :</span>Hugo Suissia
          </p>
          <p>
            <span class="font-bold text-blue-800 mr-3">Email :</span
            >hugo.suissia@gmail.com
          </p>
          <p><span class="font-bold text-blue-800 mr-3">Age :</span>28 ans</p>
          <p>
            <span class="font-bold text-blue-800 mr-3">Residence :</span
            >Lieusaint, France
          </p>
        </div>
        <hr class="border-gray-400 mx-auto w-20" />
      </div>
    </div>
  </div>
</section>
